import useSWR from 'swr'

import {
  GetRelayHealthResponse,
  ListRelayLogsResponse,
  ListRelayLogsVars,
  RelayApiPath,
} from '@/common/api/params/relay'

export const useRelayHealthApi = () => {
  return useSWR<GetRelayHealthResponse, Response, string>(RelayApiPath.GET_RELAY_HEALTH, {
    refreshInterval: 30000,
  })
}

export const useRelayLogsApi = (vars: ListRelayLogsVars) => {
  return useSWR<ListRelayLogsResponse, Response, [string, ListRelayLogsVars]>([
    RelayApiPath.LIST_RELAY_LOGS,
    vars,
  ])
}
